const BxfTextAreaConstants = {
    TEXT_AREA_DISABLED: 'disabled-area',
    TEXT_AREA_LABEL_DISABLED: 'disabled-label-area',
    TEXT_AREA_RESIZE_VERTICAL: 'disable-vertical',
    TEXT_AREA_RESIZE_HORIZONTAL: 'disable-horizontal',
    TEXT_AREA_RESIZE: 'disable-resize',
    TEXT_AREA_LABEL_WRAPPER: 'bxf-text-area-wrapper__label',
    TEXT_AREA_LABEL_WRAPPER_LEFT: 'bxf-text-area-wrapper__label--left',
    TEXT_AREA_LABEL_WRAPPER_LEFT_ERROR: 'bxf-text-area-wrapper__label--left-error',
    TEXT_AREA_LABEL_WRAPPER_LEFT_ERROR_COMPACT: 'bxf-text-area-wrapper__label--left-error-compact',
    TEXT_AREA_LABEL: 'bxf-text-area__label',
    TEXT_AREA_LABEL_COMPACT: 'bxf-text-area__label--compact',
    TEXT_AREA_LABEL_WRAPPER_LEFT_COMPACT: 'bxf-text-area-wrapper__label--left-compact',
    TEXT_AREA_LABEL_WITH_INSTRUCTIONAL_TEXT: 'bxf-text-area__label--with-instructional-text',
    TEXT_AREA_CHARACTER_COUNTER: 'bxf-text-area__character-counter',
    CHARACTER_COUNTER_INSTRUCTIONAL: 'bxf-text-area__character-counter--instructional',
    TEXT_AREA_COUNTER_CONTAINER_LEFT: 'bxf-text-area__counter-container--left',
    TEXT_AREA_LABEL_COUNTER_LEFT: 'bxf-text-area__label-counter--left',
    TEXT_AREA_LABEL_COUNTER_LEFT_INSTRUCTIONAL: 'bxf-text-area__label-counter--left-instructional',
    LEFT_LABEL: 'bxf-text-area--left',
    TEXT_AREA_LABEL_REQUIRED: 'bxf-text-area__label--required',
    TEXT_AREA_CONTAINER: 'bxf-text-area-container',
    TEXT_AREA_INNER_CONTAINER: 'bxf-text-area-inner-container',
    TEXT_AREA_BACKGROUND_ERROR: 'bxf-text-area__background--error',
    TEXT_AREA_BACKGROUND_WARNING: 'bxf-text-area__background--warning',
    TEXT_AREA_BACKGROUND_SUCCESS: 'bxf-text-area__background--success',
    TEXT_AREA: 'bxf-text-area',
    ERROR_MESSAGE: 'bxf-text-area__message--error',
    WARNING_MESSAGE: 'bxf-text-area__message--warning',
    SUCCESS_MESSAGE: 'bxf-text-area__message--success',
    INSTRUCTIONAL_TEXT: 'bxf-text-area__instructional-text',
    INSTRUCTIONAL_TEXT_COUNTER: 'bxf-text-area__instructional-text--counter',
    TEXT_AREA_SLOT_FOOTER: 'footer',
};

export { BxfTextAreaConstants as B };
